import { useEffect, useState } from 'react';
import Map from '@arcgis/core/Map';

type MapProperties = __esri.MapProperties;

/**
 * Lazily instantiates and memoizes an ArcGIS `Map` instance from the given properties, creating it once on mount.
 *
 * @param options - ArcGIS `MapProperties` used to construct the `Map`.
 * @returns The created `Map` instance, or `undefined` until it has been created.
 */
export const useEsriMap = (options: MapProperties) => {
  const [esriMap, setEsriMap] = useState<Map>();
  useEffect(() => {
    if (!esriMap) setEsriMap(new Map(options));
  }, [options, esriMap]);
  return esriMap;
};
